/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.dialog__actions[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center}.dialog__actions--compact[_ngcontent-%COMP%]{-webkit-box-pack:end;justify-content:flex-end}@media (min-width:480px){[_nghost-%COMP%]{min-width:320px}}"];
export { styles as styles };
